import UploadResumeFloating from "../UploadResumeFloating";

const JDPUploadResumeFloating =() => {
    return (
        <UploadResumeFloating
            signupSource="jdp_floating_resume"
        />
    );
};

export default JDPUploadResumeFloating;